<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <fis ref="fis"></fis>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Bills-v2") }} </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <!-- :disabled="!sayfayetki.Save" -->
              <v-btn slot="activator" @click="AddFis()" flat>
                <span class="hidden-sm-and-down">
                  <span class="hidden-sm-and-down">Fis Ekle</span>
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <!-- <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">Banka Pos Ekle</span> -->
            </v-tooltip>

            <v-menu bottom="" left>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
  <v-list-tile @click="getListHtmlSS()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }} ss</v-list-tile-title
                  >
                </v-list-tile>
                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <!-- form ınput -->
      <v-flex xs12 sm12 md12>
        <v-form ref="formgunluksatis" lazy-validation>
          <v-card flat class="pa-3">
            <v-layout row>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md2>
                    <tarihim
                      :etiket="$t('Starting-Date')"
                      :detaygizle="false"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'"
                      v-model="ListParams.FirstDate"
                    ></tarihim>
                  </v-flex>
                  <v-flex xs12 sm6 md2>
                    <tarihim
                      :etiket="$t('Finishing-Date')"
                      :detaygizle="false"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'"
                      v-model="ListParams.LastDate"
                    ></tarihim>
                  </v-flex>

                  <v-flex xs12 sm6 md3>
                    <v-layout>
                     
                      <v-btn color="info" @click="getList()" fab small dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                     
                                           
                      <v-btn
                        small=""
                        ref="fab"
                        @click.native="dialog = true"
                        color="info"
                        fab
                        dark
                      >
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm0 md1>
                                </v-flex>
 <v-flex xs12 sm6 md2>
                    <tarihim
                      :etiket="$t('Date')"
                      :detaygizle="false"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'"
                      v-model="SearchRecieptDate"
                    ></tarihim>
                  </v-flex>
                                <v-flex xs12 sm5 md2>
                                    <v-text-field
                                        label="Fiş No"
                                        v-model="SearchRecieptNumber"
                                    >
                                        <template v-slot:append-outer>
                                            <v-icon color="info" @click="searchFiche()" >send</v-icon>
                                        </template>
                                    </v-text-field>
                                </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-form>
      </v-flex>

      <!-- Sıralama ve Filtreleme -->
      <v-flex xs12 sm12 md12 pl-3 pr-3>
        <v-card width="100%" flat color="grey lighten-5">
          <v-layout row wrap align-center>
            <v-flex
              xs12
              sm12
              md9
              class="headline font-weight-regular pl-3 grey--text"
            >
              {{ totalCountText }}
            </v-flex>
            <v-flex xs12 sm12 md2 pt-2>
              <v-select
                :label="$t('Sort-By')"
                :items="siralamaItems"
                v-model="ListParams.Paging.OrderType"
                item-text="Text"
                item-value="Value"
                @change="getListPageZero()"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm12 md1 pt-2>
              <v-select
                :label="this.$t('Show')"
                :items="veriItem"
                v-model="ListParams.Paging.DataCount"
                item-text="Text"
                item-value="Value"
                @change="getListPageZero()"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <!--listeleme-->
      <v-container fluid grid-list-sm>
        <v-data-table
          :rows-per-page-items="[100]"
          :headers="headers"
          :items="items"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">
                <v-icon v-if="props.item.Currency!='' && props.item.Currency!='TRY'">attach_money</v-icon>
              </td>
              <td class="text-xs-left">
                {{ props.item.RecieptDate | dateformat }}
              </td>
              <td class="text-xs-left">
                {{ desingRecieptNumber(props.item.RecieptNumber) }} 
                <v-tooltip bottom>
                  <v-btn color="info" @click="gitDegistir(props.item)" outline fab  small slot="activator">
                  <v-icon>edit</v-icon>
                </v-btn>
                                            
                                              <span > {{ 'Fiş No Değiştir' }} </span>
                                            </v-tooltip>

              
              </td>
              <td class="text-xs-left">
                {{ props.item.ReciptType.RecieptTypeName }}
              </td>
              <td class="text-xs-left">
                {{ props.item.Center.CenterName }}
              </td>
              <td class="text-xs-left">
                {{ props.item.TotalDept }}
              </td>
              <td class="text-xs-left">
                {{ props.item.TotalCredit }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ERegistryDocDate | dateformat }}
              </td>
              <td class="text-xs-left">
                {{ props.item.RecieptTitle }}
              </td>
              <td class="text-xs-right">
                <v-btn color="info" @click="git(props.item)" outline fab small>
                  <v-icon>search</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>

      <!-- sayfalama -->
      <template v-if="vmodelpagination">
        <div class="text-xs-center">
          <v-container>
            <v-layout justify-center>
              <v-flex xs8>
                <v-pagination
                  color="info"
                  v-model="ListParams.Paging.PageNo"
                  :length="pagenumber"
                  :total-visible="6"
                ></v-pagination>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>

      <v-layout row justify-center>
        <v-dialog v-model="dialogDegistir" persistent max-width="400">
          <v-card>
            <v-card-title class="headline">Değiştir</v-card-title>
            <v-card-text>
             
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <v-text-field type="number" placeholder=""  v-model="ChangeParams.NewFicheNumber" label="Yeni Fiş No">
                                   </v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <tarihim
                      etiket="Yeni Fiş Tarihi"
                      :detaygizle="false"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'"
                      v-model="ChangeParams.NewFicheDate"
                    ></tarihim>
                              </v-flex>
                            </v-layout>

             
             
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="cancelDegistir()">İptal</v-btn>
              <v-btn color="primary" flat @click="makeChange()"
                >Kaydet</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- filtre dialog -->

      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="400">
          <v-card>
            <v-card-title class="headline">Filtreler</v-card-title>
            <v-card-text>
              <v-layout>
                              <v-flex xs12 sm6 md6>
                                <parainput :simge="getparabirimi()" v-model="ListParams.LinePriceSub"
                                  :etiket="$t('Row-Amount-Commencement')" :autocomplete="'autocomplete'" hint="Filtreden Çıkartmak İçin 0 Giriniz"></parainput>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <parainput :simge="getparabirimi()" :detaygizle="'true'"
                                  v-model="ListParams.LinePriceTop" :etiket="$t('Row-Amount-Completion')"
                                  :autocomplete="'autocomplete'"   hint="Filtreden Çıkartmak İçin 0 Giriniz"></parainput>
                              </v-flex>
                            </v-layout>
              <v-layout>
                              <v-flex xs12 sm6 md6>
                                <parainput :simge="getparabirimi()" v-model="ListParams.TotalPriceSub"
                                  :etiket="$t('Total-Amount-Commencement')" :autocomplete="'autocomplete'" hint="Filtreden Çıkartmak İçin 0 Giriniz"></parainput>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <parainput :simge="getparabirimi()" :detaygizle="'true'"
                                  v-model="ListParams.TotalPriceTop" :etiket="$t('Total-Amount-Completion')"
                                  :autocomplete="'autocomplete'"   hint="Filtreden Çıkartmak İçin 0 Giriniz"></parainput>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <v-text-field type="number" placeholder="0"  v-model="ListParams.RecieptNumberStart" label="Fiş No Başlangıç"   hint="Filtreden Çıkartmak İçin 0 Giriniz">
                                   </v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-text-field type="number" placeholder="0" hide-details="" v-model="ListParams.RecieptNumberEnd" label="Fiş No Bitiş"   hint="Filtreden Çıkartmak İçin 0 Giriniz">
                                        </v-text-field>
                              </v-flex>
                            </v-layout>

              <v-flex xs12 sm12 md12>
                <merkez v-model="CenterCode" :rules="[]"> </merkez>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <fistipi v-model="RecieptType" :rules="[]"></fistipi>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Fiş Açıklama"
                  v-model="ListParams.RecieptExplain"
                ></v-text-field>
              </v-flex>
              
                <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Fiş Satır Açıklama"
                  v-model="ListParams.LineExplain"
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Yevmiye Numarası"
                  v-model="ListParams.RegistryItemNo"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-radio-group v-model="ListParams.SearchType">
                  <v-radio label="Tüm Fişler" :value="0"></v-radio>
                  <v-radio label="Tutmayan Fişler" :value="1"></v-radio>
                  <v-radio label="Dövizli Fişler" :value="2"></v-radio>
                  <v-radio label="Miktarlı Fişler" :value="3"></v-radio>
                  <v-radio label="Sorunlu Fişler" :value="4"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="cancelFilter()">İptal</v-btn>
              <v-btn color="primary" flat @click="getListPageZero()"
                >Filtrele</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim";
import auth from "@/api/auth";
import fis from "../comp/fis.vue";
import merkez from "@/components/app/muhasebe/comp/merkez.vue";
import fistipi from "@/components/app/muhasebe/comp/fistipi.vue";
import parainput from '../../customcomp/parainput';

export default {
  data() {
    return {
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      dialog: false,
      dialogDegistir:false,
      pagenumber: 0,
      totalCountText: 0,
      vmodelpagination: false,
      CenterCode: null,
      RecieptType: null,
      BadRecieptsChk:false,
      SearchRecieptNumber:null,
      SearchRecieptDate:null,
      ChangeParams: {
        NewFicheDate:null,
        NewFicheNumber:0,
        RecieptID: 0,
      },
      ListParams: {
        LinePriceSub:0,
        LinePriceTop:0,
        RecieptNumberStart : 0,
        RecieptNumberEnd: 0,
        TotalPriceSub: null,
        TotalPriceTop: null,
        UserID: 0,
        RecieptID: 0,
        RecieptLineID: 0,
        FirstDate: null,
        LastDate: null,
        NoShowLines: true,
        RecieptExplain: null,
        RecieptType: null,
        AccountingCenter: null,
        SearchType: 0,
        CompanyID: 0,
        BadReciepts:0,
        LineExplain:null,
        PrintPageByPage:false,
        RegistryItemNo:null,
        Paging: {
          PageNo: 1,
          DataCount: 25,
          OrderType: 1,
        },
      },
      headers: [
        {
          text:"Dövizli Fiş",
          width: "5%",
          align: "center"
        },
        {
          text: "Fiş Tarihi",
        },
        {
          text: "Fiş Numarası",
        },
        {
          text: "Fiş Tip Adı",
        },
        {
          text: "Merkez Adı",
        },
        {
          text: "Toplam Borç",
        },
        {
          text: "Toplam Alacak",
        },
        {
          text: "Kayıt Tarihi",
        },
        {
          text: "Açıklama",
        },
        {
          text: "İşlem",
        },
      ],
      veriItem: [
        {
          Text: "25",
          Value: 25,
        },
        {
          Text: "50",
          Value: 50,
        },
        {
          Text: "100",
          Value: 100,
        },
      ],
      siralamaItems: [
        {
          Text: "Tarihi Artan",
          Value: 1,
        },
        {
          Text: this.$t("Date-Decreasing"),
          Value: 0,
        },
      ],
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      items: [],
    };
  },
  watch: {
    "ListParams.Paging.PageNo": function () {
      this.getList();
    },
  },
  methods: {
    gitDegistir(val)
    {
      this.ChangeParams.NewFicheDate=val.RecieptDate;
      this.ChangeParams.RecieptID=val.RecieptID;
      this.ChangeParams.NewFicheNumber=null;
      this.dialogDegistir=true;
    },
    cancelDegistir()
    {
      this.dialogDegistir=false;
    },
    makeChange()
    {
      if (this.ChangeParams.NewFicheDate==null || this.ChangeParams.NewFicheDate=='')
    {
      alert('Tarih Belirtilmeli..');
      return;
    }
      if (this.ChangeParams.NewFicheNumber==null || this.ChangeParams.NewFicheNumber=='')
    {
      this.ChangeParams.NewFicheNumber=0;
    }
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingParameters/FicheDateNumberChange",
          this.ChangeParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {

            this.loadingvmodel = false;
            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;
            this.getList();
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-FicheDateNumberChange";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-FicheDateNumberChange";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
      this.dialogDegistir=false;
    },
    getparabirimi() {
        return helpers.getparabirimi()
      },
    cancelFilter() {
      this.ListParams.RecieptNumberEnd=0;
      this.ListParams.RecieptNumberStart=0;
      this.ListParams.TotalPriceSub=null;
      this.ListParams.TotalPriceTop=null;
      this.ListParams.RecieptType = null;
      this.ListParams.AccountingCenter = null;
      this.ListParams.SearchType = 0;
      this.ListParams.RecieptExplain = null;
      this.CenterCode = null;
      this.RecieptType = null;
      this.BadRecieptsChk=false;
      this.dialog = false;
      
    },
    getListPageZero() {
      this.dialog = false;
      this.ListParams.Paging.PageNo = 1;
      this.getList();
    },
    desingRecieptNumber(val) {
      switch (val.toString().length) {
        case 1:
          return "000000000" + val;
        case 2:
          return "00000000" + val;
        case 3:
          return "0000000" + val;
        case 4:
          return "000000" + val;
        case 5:
          return "00000" + val;
        case 6:
          return "0000" + val;
        case 7:
          return "000" + val;
        case 8:
          return "00" + val;
        case 9:
          return "0" + val;
        case 10:
          return val;
        default:
          break;
      }
    },
    AddFis() {
      this.$refs.fis.open();

      // var url = "#/muhasebe/fisler/islem/id?operation=new";
      // window.open(url, "_target");
    },
    git(val) {
      var url = "#/muhasebe/fisler/detay/id?islem=get&fisID=" + val.RecieptID;
      window.open(url, "_blank");
    },
  
    searchFiche(){
     if (this.SearchRecieptDate==null)
     {
      this.text1 = "Tarih Belirtilmeli";
              this.snackbar = true;
      return;
     }
     if (this.SearchRecieptNumber==null)
     {
     
              this.text1 = "Fiş Numarası Belirtilmeli";
              this.snackbar = true;
      return;
     }
      var searchParams= {
        RecieptNumberStart : this.SearchRecieptNumber,
        RecieptNumberEnd: this.SearchRecieptNumber,
        TotalPriceSub: null,
        TotalPriceTop: null,
        UserID: 0,
        RecieptID: 0,
        RecieptLineID: 0,
        FirstDate: this.SearchRecieptDate,
        LastDate: this.SearchRecieptDate,
        NoShowLines: true,
        RecieptExplain: null,
        RecieptType: null,
        AccountingCenter: null,
        SearchType: 0,
        CompanyID: this.credentials.MuhasebeSirketNo,
        BadReciepts:0,
        Paging: {
          PageNo: 1,
          DataCount: 25,
          OrderType: 1,
        }
      };
     
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptList",
          searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            var searchItems = response.body;
            if (searchItems.length > 0) {
              this.loadingvmodel = false;
              var rcp=searchItems[0];
              this.git(rcp);
            } else {
              this.loadingvmodel = false;
              this.text1 = "Belirtilen Tarih ve Numara İçin Fiş Bulunamadı";
              this.snackbar = true;
              
            }

           
            
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );

    },
    getListHtml() {
      this.ListParams.RecieptType=null;
      this.ListParams.BadReciepts=0;
      if (this.BadRecieptsChk==true)
      {
        this.ListParams.BadReciepts=1;
      }
      if (this.ListParams.FirstDate == null) {
        this.ListParams.FirstDate = helpers.getDateNow();
        this.ListParams.LastDate = helpers.getDateNow();
      }

      if (this.CenterCode != null) {
        this.ListParams.AccountingCenter = this.CenterCode.ID;
      }

      if (this.RecieptType != null) {
        this.ListParams.RecieptType = this.RecieptType.ID;
      }
      if (this.ListParams.RecieptNumberStart==0 || this.ListParams.RecieptNumberStart=="0" || this.ListParams.RecieptNumberStart=="")
      {
        this.ListParams.RecieptNumberStart=null;
      }
      if (this.ListParams.RecieptNumberEnd==0 || this.ListParams.RecieptNumberEnd=="0" || this.ListParams.RecieptNumberEnd=="")
      {
        this.ListParams.RecieptNumberEnd=null;
      }
      if (this.ListParams.RecieptNumberStart!=null)
      {
        this.ListParams.RecieptNumberStart = Number(this.ListParams.RecieptNumberStart);
      }
      if (this.ListParams.RecieptNumberEnd!=null)
      {
        this.ListParams.RecieptNumberEnd = Number(this.ListParams.RecieptNumberEnd);
      }
      this.ListParams.CompanyID = this.credentials.MuhasebeSirketNo;
      this.ListParams.PrintPageByPage = false;
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptListHtml",
          this.ListParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
            responseType: "arraybuffer",
          }
        )
        .then(
          (response) => {
            this.progress = false;
            this.load1 = true;
            var blob = new Blob([response.data], {
              type: "application/html",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeFis.html";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
      getListHtmlSS() {
      this.ListParams.RecieptType=null;
      this.ListParams.BadReciepts=0;
      if (this.BadRecieptsChk==true)
      {
        this.ListParams.BadReciepts=1;
      }
      if (this.ListParams.FirstDate == null) {
        this.ListParams.FirstDate = helpers.getDateNow();
        this.ListParams.LastDate = helpers.getDateNow();
      }

      if (this.CenterCode != null) {
        this.ListParams.AccountingCenter = this.CenterCode.ID;
      }

      if (this.RecieptType != null) {
        this.ListParams.RecieptType = this.RecieptType.ID;
      }
      if (this.ListParams.RecieptNumberStart==0 || this.ListParams.RecieptNumberStart=="0" || this.ListParams.RecieptNumberStart=="")
      {
        this.ListParams.RecieptNumberStart=null;
      }
      if (this.ListParams.RecieptNumberEnd==0 || this.ListParams.RecieptNumberEnd=="0" || this.ListParams.RecieptNumberEnd=="")
      {
        this.ListParams.RecieptNumberEnd=null;
      }
      if (this.ListParams.RecieptNumberStart!=null)
      {
        this.ListParams.RecieptNumberStart = Number(this.ListParams.RecieptNumberStart);
      }
      if (this.ListParams.RecieptNumberEnd!=null)
      {
        this.ListParams.RecieptNumberEnd = Number(this.ListParams.RecieptNumberEnd);
      }
      this.ListParams.CompanyID = this.credentials.MuhasebeSirketNo;
      this.ListParams.PrintPageByPage = true;
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptListHtml",
          this.ListParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
            responseType: "arraybuffer",
          }
        )
        .then(
          (response) => {
            this.progress = false;
            this.load1 = true;
            var blob = new Blob([response.data], {
              type: "application/html",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeFis.html";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getListExcel() {
      this.ListParams.RecieptType=null;
      this.ListParams.BadReciepts=0;
      if (this.BadRecieptsChk==true)
      {
        this.ListParams.BadReciepts=1;
      }
      if (this.ListParams.FirstDate == null) {
        this.ListParams.FirstDate = helpers.getDateNow();
        this.ListParams.LastDate = helpers.getDateNow();
      }

      if (this.CenterCode != null) {
        this.ListParams.AccountingCenter = this.CenterCode.ID;
      }

      if (this.RecieptType != null) {
        this.ListParams.RecieptType = this.RecieptType.ID;
      }
      if (this.ListParams.RecieptNumberStart==0 || this.ListParams.RecieptNumberStart=="0" || this.ListParams.RecieptNumberStart=="")
      {
        this.ListParams.RecieptNumberStart=null;
      }
      if (this.ListParams.RecieptNumberEnd==0 || this.ListParams.RecieptNumberEnd=="0" || this.ListParams.RecieptNumberEnd=="")
      {
        this.ListParams.RecieptNumberEnd=null;
      }
      if (this.ListParams.RecieptNumberStart!=null)
      {
        this.ListParams.RecieptNumberStart = Number(this.ListParams.RecieptNumberStart);
      }
      if (this.ListParams.RecieptNumberEnd!=null)
      {
        this.ListParams.RecieptNumberEnd = Number(this.ListParams.RecieptNumberEnd);
      }
      this.ListParams.CompanyID = this.credentials.MuhasebeSirketNo;
      this.ListParams.PrintPageByPage = false;
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptListExcel",
          this.ListParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
            responseType: "arraybuffer",
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/xlsx",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeFis.xlsx";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getList() {
      this.ListParams.RecieptType=null;
      this.ListParams.BadReciepts=0;
      if (this.BadRecieptsChk==true)
      {
        this.ListParams.BadReciepts=1;
      }
      if (this.ListParams.FirstDate == null) {
        this.ListParams.FirstDate = helpers.getDateNow();
        this.ListParams.LastDate = helpers.getDateNow();
      }
      if (this.ListParams.RecieptNumberStart==0 || this.ListParams.RecieptNumberStart=="0" || this.ListParams.RecieptNumberStart=="")
      {
        this.ListParams.RecieptNumberStart=null;
      }
      if (this.ListParams.RecieptNumberEnd==0 || this.ListParams.RecieptNumberEnd=="0" || this.ListParams.RecieptNumberEnd=="")
      {
        this.ListParams.RecieptNumberEnd=null;
      }
      if (this.ListParams.RecieptNumberStart!=null)
      {
        this.ListParams.RecieptNumberStart = Number(this.ListParams.RecieptNumberStart);
      }
      if (this.ListParams.RecieptNumberEnd!=null)
      {
        this.ListParams.RecieptNumberEnd = Number(this.ListParams.RecieptNumberEnd);
      }
      if (this.CenterCode != null) {
        this.ListParams.AccountingCenter = this.CenterCode.ID;
      }

      if (this.RecieptType != null) {
        this.ListParams.RecieptType = this.RecieptType.ID;
      }
      this.ListParams.CompanyID = this.credentials.MuhasebeSirketNo;
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptList",
          this.ListParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.items = response.body;
            if (this.items.length > 0) {
              this.pagenumber = response.body[0].TotalPage;
              this.totalCountText =
                response.body[0].TotalCount + this.$t("number-records-listed");
            } else {
              this.pagenumber = 1;
              this.totalCountText = null;
            }

            this.pagenumber > 1
              ? (this.vmodelpagination = true)
              : (this.vmodelpagination = false);
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihim,
    fis,
    merkez,
    fistipi,
    parainput,
    
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
        
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      this.getList();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};
</script>

<style>
</style>

